import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { AreaChartOne } from "../../../../Constant";
import { AREA_CHART_1_DATA, AREA_CHART_1_OPTION } from "../../../../Data/Charts/GoogleChart";
import { Chart } from "react-google-charts";

const AreaChart1 = () => {
  return (
    <Col sm="12" xl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={AreaChartOne} />
        <CardBody className="p-0 chart-block">
          <div className="chart-overflow" id="area-chart1">
            <Chart chartType="AreaChart" width="100%" height="400px" data={AREA_CHART_1_DATA} options={AREA_CHART_1_OPTION} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AreaChart1;
